import React from 'react'
import { useRouter } from 'next/router'
import { GetServerSideProps } from 'next'
import Link from 'next/link'
import Image from 'next/image'

import SubMenuPage from '@features/faq/pages/SubMenuPage'
import { BASE_URL } from '@configs/config'
import { ListIcon } from '@components/icons/ListIcon'
import { maintenanceHandler } from '@lib/maintenanceHandler'

const storyMenus = [
  {
    title: 'ฉันจะสร้างนิยาย/การ์ตูนได้อย่างไร',
    url: '/faq/create-story?content=createBook',
  },
  {
    title: 'ฉันจะสร้างตัวละครได้อย่างไร',
    url: '/faq/create-story?content=createCharacter',
  },
  {
    title: 'ฉันจะสร้างนามปากกาได้อย่างไร',
    url: '/faq/create-story?content=createPenname',
  },
  {
    title: 'ฉันจะเผยแพร่งานเขียนอย่างไร',
    url: '/faq/create-story?content=publishBook',
  },
  {
    title: 'ฉันจะเผยแพร่ตัวละครอย่างไร',
    url: '/faq/create-story?content=publishCharacter',
  },
  {
    title: 'ฉันจะติดเหรียญได้อย่างไร',
    url: '/faq/create-story?content=lockChapter',
  },
]

type ContentType =
  | 'createBook'
  | 'createCharacter'
  | 'createPenname'
  | 'publishBook'
  | 'publishCharacter'
  | 'lockChapter'

const contents = {
  createBook: (
    <div>
      <h1>ฉันจะสร้างนิยาย/การ์ตูนได้อย่างไร</h1>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ&rdquo;&nbsp;
            </span>
            แล้วกดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;จักรวาลนักเขียน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            กด{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เพิ่มงานเขียน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ประเภทงานเขียน&rdquo;&nbsp;
            </span>
            ที่ต้องการสร้าง และกด{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ยืนยัน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            กรอก{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รายละเอียด&rdquo;&nbsp;
            </span>
            งานเขียนให้ครบถ้วน และกด{' '}
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;บันทึก&rdquo;
            </span>
          </div>
        </li>
      </ol>
      <p>
        &nbsp; &nbsp;&nbsp; &nbsp;{' '}
        <span className=' text-yellow font-medium italic'>
          กรณีสร้างงานเขียนครั้งแรก อย่าลืม! ไปสร้างนามปากกาก่อนนะ&nbsp;&nbsp;
        </span>
        <a href='/faq/create-story?content=createPenname' className='underline'>
          วิธีสร้างนามปากกา
        </a>
      </p>
    </div>
  ),
  createCharacter: (
    <div>
      <h1>ฉันจะสร้างตัวละครได้อย่างไร</h1>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ&rdquo;&nbsp;
            </span>
            แล้วกดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;จักรวาลนักเขียน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo; งานเขียนที่ต้องการเพิ่มตัวละคร&rdquo;&nbsp;
            </span>
            และกด&nbsp;&ldquo;
            <span className='text-primary font-medium'>แก้ไข&rdquo;</span>
          </div>
        </li>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เพิ่มตัวละคร&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            อัปโหลด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รูปภาพตัวละคร&rdquo;&nbsp;
            </span>
            จากนั้นกรอก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ชื่อตัวละคร&rdquo;&nbsp;
            </span>
            และเลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ประเภทตัวละคร&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก{' '}
            <span className='text-primary font-medium'>
              &ldquo;เผยแพร่&rdquo;
            </span>{' '}
            หากต้องการเผยแพร่ทันที กรณีต้องการเปิด{' '}
            <span className='text-primary font-medium'>
              &ldquo;สนับสนุน&rdquo;
            </span>
            ผู้ใช้สามารถ
            <a
              href='/my-writing?tab=writer'
              className='underline text-primary'
              target='_blank'
            >
              คลิกที่นี่
            </a>
            เพื่อดำเนินการยืนยันตัวตนเป็นนักเขียน
          </div>
        </li>
      </ol>
    </div>
  ),
  createPenname: (
    <div>
      <h1>ฉันจะสร้างนามปากกาได้อย่างไร</h1>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;แล้วกดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;โปรไฟล์&rdquo;
            </span>
            &nbsp;หรือ
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;ตั้งค่าโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;นามปากกา&rdquo;
            </span>
            &nbsp;หรือ
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;จัดการนามปากกา&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เพิ่มนามปากกา&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            กรอกชื่อ
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;นามปากกาหลัก&rdquo;
            </span>
            &nbsp;ที่ต้องการ (อย่างน้อย 5-50 ตัวอักษร)
            โดยสามารถใส่เป็นชื่อภาษาอื่น ๆ ได้ในช่องนามปากกาภาษาอื่น
            และใส่ลิงก์โซเชียลมีเดียนามปากกาของคุณได้
          </div>
        </li>
        <li>
          <div>
            กด
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;เพิ่ม&rdquo;
            </span>
            &nbsp;เพื่อบันทึกนามปากกา
          </div>
        </li>
      </ol>
    </div>
  ),
  publishBook: (
    <div>
      <h1>ฉันจะเผยแพร่งานเขียนอย่างไร</h1>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;แล้วกดที่
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก
            <span className='text-primary font-medium'>
              &nbsp;&ldquo;งานเขียน&rdquo;
            </span>
            &nbsp;โดยผู้ใช้สามารถเลือกเผยแพร่ได้ 2 วิธี ดังนี้
          </div>
        </li>
      </ol>
      <p className='pl-[50px]'>
        2.1 เลือกงานเขียน
        <span className='text-primary font-medium'>
          &nbsp;&ldquo;ทั้งหมด&rdquo;
        </span>
        &nbsp;หรือเลือกเฉพาะ
        <span className='text-primary font-medium'>
          &nbsp;&ldquo;งานเขียนเรื่องที่ต้องการ&rdquo;
        </span>
        &nbsp;จากนั้นให้กดเลือก
        <span className='text-primary font-medium'>
          &nbsp;&ldquo;เผยแพร่&rdquo;
        </span>
      </p>
      <p className='pl-[50px]'>
        2.2 เลือก{' '}
        <span className='text-primary font-medium'>
          &ldquo;งานเขียนที่ต้องการเผยแพร่&rdquo;
        </span>{' '}
        และกด
        <span className='text-primary font-medium'>
          &ldquo;เปลี่ยนสถานะ&rdquo;
        </span>{' '}
        งานเขียนเป็นเผยแพร่ โดยระบบจะเปลี่ยนสถานะให้อัตโนมัติทันที
      </p>
    </div>
  ),
  publishCharacter: (
    <div>
      <h1>ฉันจะเผยแพร่ตัวละครอย่างไร</h1>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;แล้วกดที่&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;จักรวาลนักเขียน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;งานเขียนที่ต้องการเผยแพร่ตัวละคร&rdquo;
            </span>
            &nbsp;และกด
            <span className='text-primary font-medium'>
              &ldquo;แก้ไข&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            กดที่เมนู&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;สามจุด&rdquo;
            </span>
            &nbsp;และเลือก&nbsp;{' '}
            <span className='text-primary font-medium'>
              &ldquo;เผยแพร่&rdquo;
            </span>
            &nbsp;โดยสามารถตั้งเวลาและกด
            <span className='text-primary font-medium'>
              &ldquo;ยืนยัน&rdquo;
            </span>{' '}
            เพื่อเผยแพร่ได้ตามเวลาที่กำหนด
          </div>
        </li>
        <li>
          <div>
            หรือเลือกเป็น{' '}
            <span className='text-primary font-medium'>
              &ldquo;ตั้งเวลาเผยแพร่และโดเนท&rdquo;
            </span>
            ผู้ใช้สามารถ
            <a
              href='/my-writing?tab=writer'
              className='underline text-primary'
              target='_blank'
            >
              คลิกที่นี่
            </a>
            เพื่อดำเนินการยืนยันตัวตนเป็นนักเขียนเพื่อเปิดใช้งานได้
          </div>
        </li>
      </ol>
    </div>
  ),
  lockChapter: (
    <div>
      <h1>ฉันจะติดเหรียญได้อย่างไร</h1>
      <p>
        ผู้ใช้บริการสามารถเลือกให้งานเขียนเป็นบริการติดเหรียญได้
        เมื่อได้รับการยืนยันตัวตนนักเขียน/สำนักพิมพ์แล้วเท่านั้น&nbsp;
        <Link href='/my-writing?tab=writer' target='_blank'>
          <a className='text-primary underline'>คลิกที่นี่</a>
        </Link>
        เพื่อดำเนินการยืนยันตัวตนนักเขียน/สำนักพิมพ์
      </p>
      <ol className='space-y-[5px]'>
        <li>
          <div>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;และกดที่&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;โปรไฟล์&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;จักรวาลนักเขียน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;งานเขียนที่ต้องการติดเหรียญ&rdquo;
            </span>
            &nbsp;และกดที่ไอคอน&nbsp;&nbsp;
            <button
              className='border border-gray-3 bg-white rounded-[8px] px-[4px] h-[30px]'
              type='button'
              disabled
            >
              <ListIcon />
            </button>
          </div>
        </li>
        <li>
          <div>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;จัดการตอน&rdquo;
            </span>
          </div>
        </li>
        <li>
          <div className='flex'>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;ตอนที่ต้องการติดเหรียญ&rdquo;
            </span>
            &nbsp;จากนั้นให้กดเลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;ตั้งราคา&rdquo;
            </span>
            <div className='w-[100px]'>
              <div className='relative w-full h-full pt-[75.39%]'>
                <Image src='/add-coin.png' layout='fill' />
              </div>
            </div>
            &nbsp;และระบุจำนวนที่ต้องการติดเหรียญ
          </div>
        </li>
        <li>
          <div>
            กด{' '}
            <span className='text-primary font-medium'>
              &ldquo;ยืนยัน&rdquo;
            </span>{' '}
            เพื่อตั้งราคา
          </div>
        </li>
      </ol>
    </div>
  ),
}

const defaultBreadCrumb = [
  { title: 'คำถามที่พบบ่อย', url: '/faq' },
  { title: 'การสร้างเรื่อง / ตอน', url: '/faq/create-story' },
]

function CreateStory({ url }: { url: string }) {
  const { query } = useRouter()

  return (
    <SubMenuPage
      menus={storyMenus}
      breadCrumbList={
        query?.content
          ? [
              ...defaultBreadCrumb,
              {
                title:
                  storyMenus.find(m => m.url.includes(String(query.content)))
                    ?.title || '',
                url:
                  storyMenus.find(m => m.url.includes(String(query.content)))
                    ?.url || '',
              },
            ]
          : defaultBreadCrumb
      }
      content={contents[query?.content as ContentType]}
      url={url}
    />
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}

export default CreateStory
